import { PartitionOutlined, TeamOutlined } from '@ant-design/icons'
import { useState } from 'react'

import AtomSwitch from '@/components/Atoms/AtomSwitch/AtomSwitch'
import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './Clients.module.scss'
import ClientsTab from './tabs/Clients/ClientsTab'
import {
  type ClientsSortDir,
  getNextClientsSortDir,
} from './tabs/Clients/ClientsTab.config'
import SegmentsTab from './tabs/Segments/SegmentsTab'

type ClientsSection = 'clients' | 'segments'

const SECTION_OPTIONS = [
  {
    value: 'clients' as const,
    label: 'Клиенты',
    icon: <TeamOutlined aria-hidden />,
  },
  {
    value: 'segments' as const,
    label: 'Сегменты',
    icon: <PartitionOutlined aria-hidden />,
  },
]

function Clients() {
  const [currentTab, setCurrentTab] = useState<ClientsSection>('clients')
  const [clientsSortDir, setClientsSortDir] = useState<ClientsSortDir | null>(
    null
  )
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )

  return (
    <section className={cn.clients}>
      <div className={cn.inner}>
        <div className={cn.tabs}>
          <AtomSwitch
            options={SECTION_OPTIONS}
            value={currentTab}
            onChange={setCurrentTab}
            ariaLabel="Работа с клиентами"
            isOrganisationSelected={isOrganisationSelected}
          />
        </div>
        {currentTab === 'clients' && (
          <ClientsTab
            sortDir={clientsSortDir}
            onToggleSort={() => setClientsSortDir(getNextClientsSortDir)}
          />
        )}
        {currentTab === 'segments' && <SegmentsTab />}
      </div>
    </section>
  )
}

export default Clients
